const POSSIBLE_ALIGN = {
  left: 'start',
  center: 'center',
  right: 'end',
};

export const bootstrapMigrationLeftRightToStartEnd = value => POSSIBLE_ALIGN[value] ?? value;
